export const Form = {
  name: {
    component: 'FormText',
    label: 'Name',
    defaultValue: ''
  },
  desc: {
    component: 'FormMarkdown',
    label: 'Description',
    defaultValue: ''
  },
  image: {
    component: 'FormImage',
    label: 'Image',
    defaultValue: '',
    rules: { required: false }
  },
  color: {
    component: 'FormColor',
    label: 'Color',
    defaultValue: ''
  },
  backgroundColor: {
    component: 'FormColor',
    label: 'Background Color',
    defaultValue: ''
  },
  gender: {
    component: 'FormSelectGender',
    label: 'Gender',
    defaultValue: 'MALE'
  },
  brandIds: {
    component: 'FormBrandList',
    label: 'Brands',
    defaultValue: []
  },
  wrestlerIds: {
    component: 'FormWrestlerList',
    label: 'Champions',
    defaultValue: []
  },
  minPoints: {
    component: 'FormNumber',
    label: 'Min Points',
    defaultValue: 50,
    rules: { min: 0, max: 100 }
  },
  rank: {
    component: 'FormNumber',
    label: 'Rank',
    defaultValue: 100,
    rules: { min: 0, max: 100 }
  },
  maxPoints: {
    component: 'FormNumber',
    label: 'Max Points',
    defaultValue: 100,
    rules: { min: 0, max: 100 }
  },
  holders: {
    component: 'FormNumber',
    label: 'Amount of holders',
    defaultValue: 1,
    rules: { min: 0, max: 10 }
  }
}

export const RelationForm = {
  gender: {
    component: 'FormSelectGender',
    label: 'Gender',
    defaultValue: 'MALE'
  },
  brandIds: {
    component: 'FormBrandList',
    label: 'Brands',
    defaultValue: []
  },
  wrestlerIds: {
    component: 'FormWrestlerList',
    label: 'Champions',
    defaultValue: []
  }
}

export const QuickForm = {}

export default Form
